import { GatewayStatus } from 'constants/gatewayStatuses';
import { Resources } from 'constants/resources';

import { GatewaysChip } from 'pages/Gateways/components/GatewaysChip/GatewaysChip';
import { GatewayStatusSelectInput } from 'pages/Gateways/components/GatewayStatusSelectInput/GatewayStatusSelectInput';
import { useWatch } from 'react-hook-form';
import { AutocompleteInput, SelectInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { getId } from 'utils';

type Props = {
  onProviderInputChange?: () => void;
  providerFilter?: { name: string };
};

export const GatewaysCreateMainFields: React.FC<Props> = ({
  onProviderInputChange,
  providerFilter,
}) => {
  const status = useWatch({ name: 'status' });

  const isGatewayDisabled = getId(status) === GatewayStatus.Disabled;

  return (
    <>
      <TextInput
        fullWidth
        isRequired
        label="Алиас"
        size="small"
        source="alias"
        variant="outlined"
      />
      <GatewayStatusSelectInput />
      <ReferenceInput
        filter={providerFilter}
        perPage={200}
        reference={Resources.Providers}
        source="provider"
      >
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          fullWidth
          isRequired
          label="Провайдер"
          onInputChange={onProviderInputChange}
          optionText="name"
          size="small"
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput reference={Resources.GatewayDirections} source="direction">
        <SelectInput
          fullWidth
          isRequired
          label="Направление"
          optionText={<GatewaysChip />}
          size="small"
          source="value"
          variant="outlined"
        />
      </ReferenceInput>
      {isGatewayDisabled && (
        <ReferenceInput
          perPage={200}
          reference={Resources.GatewayDeactivationReasons}
          source="deactivationReason"
        >
          <AutocompleteInput
            filterToQuery={(searchText: string) => ({ name: searchText })}
            fullWidth
            isRequired
            label="Причина деактивации"
            optionText="reason"
            size="small"
            variant="outlined"
          />
        </ReferenceInput>
      )}
    </>
  );
};
